export const dogBreeds = [
  'Labrador Retriever',
  'German Shepherd',
  'Golden Retriever',
  'Bulldog',
  'Beagle',
  'French Bulldog',
  'Poodle',
  'Rottweiler',
  'Yorkshire Terrier',
  'Boxer',
  'Siberian Husky',
  'Dachshund',
  'Doberman Pinscher',
  'Chihuahua',
  'Shih Tzu',
  'Great Dane',
  'Miniature Schnauzer',
  'Cavalier King Charles Spaniel',
  'Pomeranian',
  'Australian Shepherd',
];
